module Hereabout.UI.Components.CommunityFeedComponent where

import Prelude

import Data.Array as A
import Data.Maybe (Maybe(..))
import Effect.Class (class MonadEffect)
import Halogen as H
import Halogen.HTML as HH
import Halogen.HTML.Events as HE
import Halogen.HTML.Properties as HP
import Hereabout.Data.Route (CommunityFeedTab(..), Route(..))
import Hereabout.Effects (class Navigate, class ShareURL, navigate)
import Hereabout.Types (CommunityFeed(..), Event(..), Venue(..))
import Hereabout.UI.Bits (renderIcon)
import Hereabout.UI.Bulma.Classes as Bulma
import Hereabout.UI.Components.ContentComponent as ContentComp
import Hereabout.UI.Components.EventPreviewComponent as EventPrvComp
import Hereabout.UI.Components.VenuePreviewComponent as VenuePrvComp
import Hereabout.UI.SemanticUI.Classes as SemUI
import Type.Proxy (Proxy(..))

data Action
  = SelectState CommunityFeedTab

type Slot id = forall q. H.Slot q Void id



type Input =
  { communityFeed :: CommunityFeed
  , cfTab :: CommunityFeedTab
  }

type State =
  { communityFeed :: CommunityFeed
  , cfTab :: CommunityFeedTab
  }

type ChildSlots =
  ( eventPreviews :: EventPrvComp.Slot Int
  , venuePreviews :: VenuePrvComp.Slot Int
  , contentComp :: ContentComp.Slot Unit
  )

component :: forall q o m. MonadEffect m => Navigate m => ShareURL m => H.Component q Input o m
component =
  H.mkComponent
    { initialState: \s -> s
    , render
    , eval: H.mkEval H.defaultEval { handleAction = handleAction }
    }

render :: forall m. MonadEffect m => Navigate m => ShareURL m => State -> H.ComponentHTML Action ChildSlots m
render state =
  HH.div []
    [ renderLocation (state.communityFeed)
    ,  HH.div [ HP.classes [ Bulma.tabs, Bulma.isToggle, Bulma.isCentered, Bulma.isMedium ] ]
      [ HH.ul_ [
          HH.li [ HP.classes $ activeClasses CommunityFeedEventTab state.cfTab ]
          [ HH.a [ HE.onClick \_ -> SelectState CommunityFeedEventTab ]
            [ renderIcon "fa-calendar-days" $ HH.text "Events"
            ]
          ]
        , HH.li [ HP.classes $ activeClasses CommunityFeedVenueTab state.cfTab  ]
          [ HH.a [ HE.onClick \_ -> SelectState CommunityFeedVenueTab ]
            [ renderIcon "fa-building" $ HH.text "Venues"
            ]
          ]
        ]
      ]
    , case state.cfTab of
        CommunityFeedEventTab -> renderEvents cf.events
        CommunityFeedVenueTab -> renderVenues cf.venues
    ]
    where
      CommunityFeed cf = state.communityFeed
      activeClasses a b | a == b = [ Bulma.isActive ]
      activeClasses _ _ = []


renderLocation :: forall m. MonadEffect m => CommunityFeed -> H.ComponentHTML Action ChildSlots m
renderLocation (CommunityFeed cf) = 
  HH.section [ HP.classes [Bulma.section] ] $
    [ HH.h1 [ HP.classes [ Bulma.title ] ] [ HH.text cf.name ]
    , HH.p_ 
      [ HH.slot_ (Proxy :: _ "contentComp") unit ContentComp.component cf.content
      ]
    , HH.p [ HP.classes [ Bulma.mt3 ] ]
      [ HH.a [ HP.href cf.repoUrl, HP.title "Edit community metadata on Github" ]
        [ renderIcon "fa-pen-to-square" $ HH.text "Edit"
        ]
      ]
    ]

renderEvents :: forall m. MonadEffect m => Navigate m => ShareURL m => Array Event -> H.ComponentHTML Action ChildSlots m
renderEvents events | A.length events > 0 = 
  HH.div [ HP.classes [Bulma.block] ] 
    [ HH.div [ HP.classes [ Bulma.fixedGrid, Bulma.has3ColsDesktop, Bulma.has1ColsMobile, Bulma.has2ColsTablet ]  ]
      [ HH.div [ HP.classes [ Bulma.grid ] ] $
        A.mapWithIndex (\i item ->
          HH.div [ HP.classes [ Bulma.cell] ]
          [ HH.slot_ (Proxy :: _ "eventPreviews") i EventPrvComp.component item
          ]
        ) events
      ]
    ]
renderEvents _ = 
  HH.div [ HP.classes [Bulma.block] ]
    [ HH.text "No events available in this area just yet. Please stay tuned for updates!"
    ]

renderVenues ::forall m. MonadEffect m => Navigate m => Array Venue ->  H.ComponentHTML Action ChildSlots m
renderVenues venues | A.length venues > 0  = 
  HH.div [ HP.classes [Bulma.block] ] 
    [ HH.div [ HP.classes [ Bulma.fixedGrid, Bulma.has3ColsDesktop, Bulma.has1ColsMobile, Bulma.has2ColsTablet ]  ]
      [ HH.div [ HP.classes [ Bulma.grid ] ] $
          A.mapWithIndex (\i item ->
            HH.div [ HP.classes [ Bulma.cell] ]
            [ HH.slot_ (Proxy :: _ "venuePreviews") i VenuePrvComp.component item
            ]
          ) venues
      ]
    ]
renderVenues _ =
  HH.div [ HP.classes [Bulma.block] ]
    [ HH.text "No venues available in this area just yet. Please stay tuned for updates!"
    ]

handleAction :: forall cs o m. Navigate m => Action -> H.HalogenM State Action cs o m Unit
handleAction (SelectState state) = do
  st <- H.get
  let (CommunityFeed cf) = st.communityFeed
  if state /= st.cfTab then
    case state of
      CommunityFeedEventTab -> H.lift $ navigate $ CommunityRoute cf.id
      CommunityFeedVenueTab -> H.lift $ navigate $ CommunityRouteVenueTab cf.id
  else
    pure unit

